import Styles from './Sidebar.module.scss'

import { SidebarProps } from './Types'
import { FolderPlus2, Upload, Loader2 } from 'blaze-ui/icons'
import { Button } from 'blaze-ui/Button'
import { useModals } from 'almanac-ui/Modal'
import { NewProjectModal } from 'components/BlazeCommandLine/modals/NewProjectModal'
import Avatar from 'common/Avatar/Avatar'
import { getInitials } from 'utils'
import { useCurrentUserProfile } from 'hooks/queries/users/useCurrentUserProfile'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { generatePath, useHistory } from 'react-router-dom'
import { BRAND_KITS_PATH, UPLOADS_PATH } from 'paths'
import cx from 'classnames'
import { useMemo } from 'react'
import { CATEGORIES_DESKTOP } from '../constants'
import { useIsVirtualMarketer } from 'hooks/useIsVirtualMarketer'

export const Sidebar = ({
  selectedCategory,
  setSelectedCategory,
  showNewProjectButton,
  parentFolder,
  search,
  usingRecentWizards,
  forYouPageType,
  subCategory,
}: SidebarProps) => {
  const { openModal, closeAllModals } = useModals()
  const { data: profile } = useCurrentUserProfile()
  const workspaceId = useCurrentWorkspaceId()
  const history = useHistory()
  const isAutopilot = useIsVirtualMarketer()

  const forYouTitle = useMemo(() => {
    switch (forYouPageType) {
      case 'recently_used':
        return 'Recently Used'
      case 'getting_started':
        return 'Getting Started'
      case 'power_up':
        return 'Power Up'
    }
  }, [forYouPageType])

  const activeCategory = useMemo(() => {
    if (subCategory || search) {
      return undefined
    }

    if (selectedCategory) {
      return selectedCategory
    }

    return undefined
  }, [search, selectedCategory, subCategory])

  return (
    <div className={Styles.sidebar}>
      <div className={Styles.sidebarTop}>
        {CATEGORIES_DESKTOP.map(({ name, title, icon }) => {
          const showGettingStarted = name === 'For You' && !usingRecentWizards
          const showForYou = name === 'For You' && usingRecentWizards

          return (
            <div key={name} className={cx(Styles.sidebarItem, { [Styles.gettingStartedButton]: showGettingStarted })}>
              <Button
                forceActive={activeCategory === name}
                justifyContent="flex-start"
                variant="editor"
                frontIcon={showGettingStarted ? Loader2 : icon}
                fullWidth
                preventFocusOnPress
                onPress={() => {
                  setSelectedCategory(name)
                }}
              >
                {showForYou && (
                  <div className={Styles.avatarContainer}>
                    <Avatar
                      url={profile?.profile_image_url || profile?.avatar_url}
                      label={getInitials(profile?.display_name)}
                      size={20}
                      workspaceId={workspaceId}
                    />
                  </div>
                )}
                {name === 'For You' ? forYouTitle : title}
              </Button>
            </div>
          )
        })}
      </div>
      <div className={Styles.sidebarBottom}>
        <Button
          justifyContent="flex-start"
          variant="editor"
          size="md"
          frontIcon={Upload}
          fullWidth
          onPress={() => {
            closeAllModals()
            const path = isAutopilot
              ? `${generatePath(BRAND_KITS_PATH, { workspaceId })}#images_videos`
              : generatePath(UPLOADS_PATH, { workspaceId })
            history.push(path)
          }}
        >
          Upload
        </Button>

        {showNewProjectButton && (
          <Button
            justifyContent="flex-start"
            frontIcon={FolderPlus2}
            variant="editor"
            size="md"
            fullWidth
            onPress={() => openModal(NewProjectModal, { parentFolder })}
          >
            New Project
          </Button>
        )}
      </div>
    </div>
  )
}
